import { MAP } from "./content";

// "Getting here" map for /100 — a single embedded Google Map pinned on the
// Queenstown Marina place marker, with the getting-here copy kept as text
// alongside it. A plain Google Maps embed can't natively reproduce the mockup's
// here/family category toggle + legend, so that interaction is intentionally
// dropped; the family context (Bathe, central Queenstown) lives in the
// directions copy instead. The embed is the no-API-key `output=embed` URL, so
// this card adds no dependency and no map key. Per review it renders fully
// de-saturated (no colour) and the "Open in Google Maps" button is removed.

export function MembershipMap() {
  return (
    <div className="grid gap-8 lg:grid-cols-[1fr_1.4fr] lg:items-stretch">
      <div className="flex flex-col justify-center">
        <p className="max-w-[46ch] text-[17px] font-light leading-relaxed text-ink-on-dark/80">{MAP.directions}</p>
      </div>
      <iframe
        title="Map centred on Queenstown Marina"
        src={MAP.embedUrl}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
        className="h-[min(560px,66vh)] w-full rounded-lg border border-[color:var(--rule-on-dark)]"
        style={{ filter: "grayscale(1)" }}
      />
    </div>
  );
}
